import Axios from "axios";
import { store } from "../redux/store";
import { notAuthorized } from "../redux/auth/actions";
import { DropDownAlert } from "../components";

export const ApiServer = Axios.create({
    timeout: 60000,
});

ApiServer.interceptors.request.use(
    function (config) {
        const user = store.getState().Auth.user;
        config.headers.Authorization = user ? user.token : undefined;
        config.headers["X-DAYA-EMAIL"] = user ? user.email : undefined;
        config.headers["X-DAYA-ROLE"] = user ? user.user_type.type_name : undefined;
        // console.log('[ApiServer Request]: ', config);
        return config;
    },
    function (error) {
        // console.log('[ApiServer Request Error]: ', error.response);
        return Promise.reject(error);
    }
);

ApiServer.interceptors.response.use(
    function (response) {
        // console.log('[ApiServer Response]: ', response);
        return response;
    },
    function (error) {
        // console.log('[ApiServer Response Error]: ', error.response);
        if (error.response && error.response.status === 401) {
            store.dispatch(notAuthorized());
        }
        if (error.response && error.response.status === 400 && error.response.data) {
            const { info } = error.response.data;
            if (info) DropDownAlert.show("danger", info.err_message);
        }
        if (error.response && error.response.status === 500) {
            DropDownAlert.show("danger", "Saat ini kami sedang melalukan perbaikan, kami akan segera melayan anda!");
        }
        if (!error.response) {
            DropDownAlert.show("danger", "Mohon periksa koneksi jaringan anda!");
        }
        return Promise.reject(error);
    }
);

class ApiRequest {
    static post(url, reqBody) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ApiServer.post(`${process.env.REACT_APP_API_URL}${url}`, reqBody);
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    }

    static async get(url, configs) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ApiServer.get(`${process.env.REACT_APP_API_URL}${url}`, configs);
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    }

    static async getDocument(productId, requestBody) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ApiServer.post(
                    `${process.env.REACT_APP_API_DOCUMENT}/v1/daya/generate/${productId}/daya-borrower`,
                    requestBody,
                    {
                        responseType: "blob",
                    }
                );
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    }

    static async getExportData(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ApiServer.get(`${process.env.REACT_APP_API_EXPORT}/api/private/v1/${params}`, {
                    responseType: "blob",
                });
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    }

    static getRecording(url, configs) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ApiServer.get(`${process.env.REACT_APP_API_RECORDING}${url}`, configs);
                resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    }
}

export default ApiRequest;
